import request from '@/utils/request'

// 获取组列表
export const group = (params)=>{
  return request({
    url: '/admin-api/client/pc/group/get',
    method: 'get',
    params: params
  })
}


// 创建组
export const createGroup = (data)=>{
  return request({
    url: '/admin-api/client/pc/group/create',
    method: 'post',
    data: data
  })
}


// 删除组
export const deleteGroup = (params)=>{
  return request({
    url: '/admin-api/client/pc/group/delete',
    method: 'delete',
    params: params
  })
}

// 更新场景管理
export const updateGroup = (data)=>{
  return request({
    url: '/admin-api/client/pc/group/update',
    method: 'put',
    data: data
  })
}

// 获得组管理分页
export const groupPage = (params)=>{
  return request({
    url: '/admin-api/client/pc/group/page',
    method: 'get',
    params: params
  })
}
